import React from 'react';
import styled from 'styled-components'
import Utils from './Utils'

import PageWrapper from './PageWrapper';
import { ColFlexDiv, Robot, RowFlexDiv, MixerlabText, DeltaRightIcon, DeltaUpIcon } from './Components';
import { BigFigure, InformationItem, Header, RoleDetailsContainer, SessionPremise, CountdownWrapper } from './Components';

class BotSession extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      feedback: '',
      user_number: '',
      feedbackChange: null,
      num_accepted: 0,
      num_rejected: 0,
      num_in_progress: 0,
      detailedFeedbackView: false,
      remainingMinutes: null,
      refreshCount: 0,
      actor_session_code: ''
    };
  }

  componentDidMount() {
    this.setState({
      feedback: this.props.feedback,
      num_accepted: this.props.num_accepted,
      num_rejected: this.props.num_rejected,
      num_in_progress: this.props.num_in_progress,
    })
    this.updateState();
  }

  componentDidUpdate(prevProps) {
    if(prevProps.feedback !== this.props.feedback) {
      this.setState({feedback: this.props.feedback});
    };
    if(prevProps.num_accepted !== this.props.num_accepted) {
      this.setState({num_accepted: this.props.num_accepted});
    };
    if(prevProps.num_rejected !== this.props.num_rejected) {
      this.setState({num_rejected: this.props.num_rejected});
    };
    if(prevProps.num_in_progress !== this.props.num_in_progress) {
      this.setState({num_in_progress: this.props.num_in_progress});
    }
  }

  updateState() {
    const baseUrl = '/actor/session_updates/';
    let endpoint;
    if (this.props.sessionSource === 'bot' || this.props.sessionSource === 'bot_training') {
        endpoint = `${baseUrl}${this.props.sessionSource}`;
    }
    Utils.apiGet(endpoint).then((response) => {
        this.setState({
          feedback: response.data.feedback,
          num_accepted: response.data.num_accepted,
          num_rejected: response.data.num_rejected,
          num_in_progress: response.data.num_in_progress,
          remainingMinutes: response.data.remaining_minutes
      })
    }).then(() => {this.updateStatePeriodically()})
  }

  updateStatePeriodically() {
    if (this.periodicStatusCheck) {
      window.clearTimeout(this.periodicStatusCheck);
      this.periodicStatusCheck = null;
    }

    this.periodicStatusCheck = window.setTimeout(
      this.updateState.bind(this),
      30000
    );
  }

  renderFeedback() {
    return (
      <div style={{'width': '100%'}}>
        <MixerlabText>
          Please note, due to processing times, it may take a few minutes for each call to appear here.
          <RowFlexDiv>
            <ColFlexDiv style={{'alignItems':'start', 'margin': '10px'}}>
              <BigFigure style={{'marginLeft':'10px'}} >
                {this.state.num_accepted}
                </BigFigure>
              <InformationItem>Accepted Conversations</InformationItem>
            </ColFlexDiv>
            <ColFlexDiv style={{'alignItems':'start', 'margin': '10px'}}>
              <BigFigure style={{'marginLeft':'10px'}}>{this.state.num_rejected}</BigFigure>
              <InformationItem>Rejected Conversations</InformationItem>
            </ColFlexDiv>
            <ColFlexDiv style={{'alignItems':'start', 'margin': '10px'}}>
              <BigFigure style={{'marginLeft':'10px'}}>{this.state.num_in_progress}</BigFigure>
              <InformationItem>Conversations Processing</InformationItem>
            </ColFlexDiv>
            </RowFlexDiv>
          {!this.state.detailedFeedbackView && <div style={{'marginLeft': '10px'}} onClick={() => this.setState({detailedFeedbackView: true})}>View Conversation Details: <DeltaRightIcon /></div>}
          {this.state.detailedFeedbackView && <div style={{'marginLeft': '10px'}} onClick={() => this.setState({detailedFeedbackView: false})}>Collapse Conversation Details: <DeltaUpIcon /></div>}
          {(this.state.detailedFeedbackView) && 
            <div>
              {this.state.feedback &&
                <ul>
                  {this.state.feedback.split('\n').map((line) => {
                    if (line !== '') {
                      return(<li>{line}</li>)
                    }
                    })}
                </ul>
              }
            </div>
          }
        </MixerlabText>
      </div>
    )
  }

  renderMinutesRemaining() {
    return (
      <div>
        {(this.state.remainingMinutes>0 && this.state.remainingMinutes<=1) && <CountdownWrapper>The current Bot Session will end in 1 minute! Please wrap up your current call, no new calls starting at this time will be recorded.</CountdownWrapper>}
        {(this.state.remainingMinutes<=0) && 
        <div>
          <CountdownWrapper>The current Bot Session has ended, thank you for participating! Please wrap up your current call, no new calls starting at this time will be recorded.</CountdownWrapper>
          <MixerlabText>
            <p>Please return to your <a href="/profile/me">profile</a> to view your payment and performance records for this session. </p>
            <p>Please note, due to processing times, it may take up to 10 minutes for your records to be finalized. </p>
          </MixerlabText>
        </div>
        }
        {(this.state.remainingMinutes>1) && <CountdownWrapper>{this.state.remainingMinutes} Minutes Left</CountdownWrapper>}
      </div>
    )
  }

  render() {
    this.updateStatePeriodically();
    let sessionPremise = this.props.sessionPremise.replaceAll("&#39;", "\'").replaceAll("&#34;", "\"");
    let callerScene = this.props.callerScene.replaceAll("&#39;", "\'").replaceAll("&#34;", "\"");
    return (
      <PageWrapper isAdmin={this.props.isAdmin}>
        <SessionPremise>{sessionPremise.toUpperCase()}</SessionPremise>
        {(this.state.remainingMinutes || (this.state.remainingMinutes === 0)) && this.renderMinutesRemaining()}
        {(this.state.remainingMinutes>0) &&
        <div>
          <div style={{'width': '100%'}}>
            <Header>Feedback</Header>
            {this.renderFeedback()}
            <Header>Session Instructions</Header>
            <MixerlabText>{this.props.instructions.replaceAll("&#39;", "\'").replaceAll("&#34;", "\"")}</MixerlabText>
          </div>
          <RoleDetailsContainer>
            <ColFlexDiv style={{'width': '100%'}}>
              <ColFlexDiv style={{'width': '25%'}}>
                <Header>Role details</Header>
                <Robot/>
              </ColFlexDiv>   
            <MixerlabText style={{'textAlign': 'center'}}>
              <div>{callerScene}</div>
            </MixerlabText>
            <MixerlabText style={{'textAlign': 'center'}}>
                <strong>Call {this.props.botNumber} to talk to Grace.</strong>
                <div style={{'marginTop': '10px'}}>Please make sure to call in from {this.props.user_number}, the phone number associated with your mixer account. PLEASE DO NOT USE VOIP SERVICES. These will hide your phone number from us. If after one call you do not see your counters increasing, do not continue to call.</div>
            </MixerlabText>
            </ColFlexDiv> 
          </RoleDetailsContainer>
        </div>
      }
      </PageWrapper>
    );
  }
}

export default BotSession;